import Glide from "@glidejs/glide";
import Heading from "components/Heading/Heading";
import React, { FC, useEffect } from "react";
import clientSayMain from "images/clientSayMain.png";
import clientSay1 from "images/clientSay1.png";
import clientSay2 from "images/clientSay2.png";
import clientSay3 from "images/clientSay3.png";
import clientSay4 from "images/clientSay4.png";
import clientSay5 from "images/clientSay5.png";
import clientSay6 from "images/clientSay6.png";
import quotationImg from "images/quotation.png";
import quotationImg2 from "images/quotation2.png";
import useNcId from "hooks/useNcId";

export interface SectionClientSayProps {
  className?: string;
  uniqueClassName: string;
}

// Real Google reviews from NomadRoof students
const GOOGLE_REVIEWS = [
  {
    id: 1,
    clientName: "Giancarlo Z.",
    clientAddress: "Exchange Student",
    content:
      "I spent pretty much one full year studying in Lima and Depa Mancora became like a second home to me! Also thanks to NomadRoof there was always a trip or party organised for us exchange students!",
    rating: 5,
  },
  {
    id: 2,
    clientName: "Cedric Gräbner",
    clientAddress: "Exchange Student",
    content:
      "NomadRoof not only provided me with the perfect accommodation for my six-month stay, but also gave me the best experiences I had during that time. I will always remember the trip to Huaraz.",
    rating: 5,
  },
  {
    id: 3,
    clientName: "Will Randolph",
    clientAddress: "Exchange Student",
    content:
      "I had an unforgettable experience with NomadRoof, not only housing but also with group trips that they plan to different destinations in Peru. We went to Huaraz, the amazon, and even to Ayacucho. Very fun times all around.",
    rating: 5,
  },
  {
    id: 4,
    clientName: "Ronja Väisänen",
    clientAddress: "Exchange Student",
    content:
      "I had a great experience with NomadRoof and felt immediately welcomed into a warm and open atmosphere. The trip was truly unforgettable, bringing new experiences, friendships, and a strong sense of belonging.",
    rating: 5,
  },
  {
    id: 5,
    clientName: "Julian Marrink",
    clientAddress: "Exchange Student",
    content:
      "I have had a great time in casa madrid. This was a good place to stay and located in a really nice area. Thanks for the semester!",
    rating: 5,
  },
  {
    id: 6,
    clientName: "Tanja Greiderer",
    clientAddress: "Exchange Student",
    content:
      "I stayed at Casa Pisco in the master room with a balcony during my exchange semester and really enjoyed it. The house is quiet, the neighborhood is great with cafés and shops nearby. Perfect spot for students!",
    rating: 5,
  },
  {
    id: 7,
    clientName: "Alex Kovacs",
    clientAddress: "Exchange Student",
    content:
      "I spent an excellent semester in the house. Mama Doris was truly a second mother to all of us, and the community was alive and vibrant.",
    rating: 5,
  },
  {
    id: 8,
    clientName: "Agathe Mazurek",
    clientAddress: "Exchange Student",
    content:
      "I had an amazing time with NomadRoof! They make your semester abroad truly unforgettable by organising amazing events, weekly parties and incredible trips all around Peru! It's a fantastic community where you meet amazing people.",
    rating: 5,
  },
  {
    id: 9,
    clientName: "Zoe Am Ende",
    clientAddress: "Exchange Student",
    content:
      "The exchange semester wouldn't have been the same without NomadRoof! It is an amazing community and I met some of the most incredible people. The trips and parties are the cherry on top!",
    rating: 5,
  },
  {
    id: 10,
    clientName: "Alexandra Becker",
    clientAddress: "Exchange Student",
    content:
      "I spent 4 months in Depa Mancora. Thanks to the guys from NomadRoof I had an amazing time in Lima and all of Peru. I can only recommend joining the NomadRoof community because you will find a second family!",
    rating: 5,
  },
  {
    id: 11,
    clientName: "Justin Aigu",
    clientAddress: "Exchange Student",
    content:
      "This chill shared house is a real peaceful haven, perfectly located for getting around on foot. The vibe is cool and quiet, ideal if you're looking for a friendly spot.",
    rating: 5,
  },
  {
    id: 12,
    clientName: "Inès Badiou",
    clientAddress: "Exchange Student",
    content:
      "I 100% recommend NomadRoof! They're very responsive if you have any needs, they organize amazing events, and they keep you entertained throughout your exchange experience.",
    rating: 5,
  },
];

// TODO: Replace with your actual Google Business Profile URL
const GOOGLE_BUSINESS_URL = "https://www.google.com/maps/search/?api=1&query=NomadRoof";

const SectionClientSay: FC<SectionClientSayProps> = ({
  className = "",
  uniqueClassName = "",
}) => {
  const UNIQUE_CLASS = `SectionClientSay_glide_${uniqueClassName}` + useNcId();

  useEffect(() => {
    const glideElement = document.querySelector(`.${UNIQUE_CLASS}`) as HTMLElement;
    if (glideElement) {
      setTimeout(() => {
        new Glide(glideElement, {
          perView: 1,
          autoplay: 5000,
          hoverpause: true,
          animationDuration: 600,
        })?.mount();
      }, 10);
    }
  }, [UNIQUE_CLASS]);

  const renderStars = (rating: number) => {
    return (
      <div className="flex items-center gap-1 justify-center">
        {[...Array(5)].map((_, index) => (
          <svg
            key={index}
            className={`w-5 h-5 ${
              index < rating ? "text-yellow-400 fill-yellow-400" : "text-gray-300 fill-gray-300"
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        ))}
      </div>
    );
  };

  const renderBg = () => {
    return (
      <div className="hidden md:block">
        <img className="absolute top-9 -left-20 opacity-70" src={clientSay1} alt="" />
        <img
          className="absolute bottom-[100px] right-full mr-40 opacity-70"
          src={clientSay2}
          alt=""
        />
        <img
          className="absolute top-full left-[140px] opacity-70"
          src={clientSay3}
          alt=""
        />
        <img
          className="absolute -bottom-10 right-[140px] opacity-70"
          src={clientSay4}
          alt=""
        />
        <img
          className="absolute left-full ml-32 bottom-[80px] opacity-70"
          src={clientSay5}
          alt=""
        />
        <img className="absolute -right-10 top-10 opacity-70" src={clientSay6} alt="" />
      </div>
    );
  };

  return (
    <div
      className={`nc-SectionClientSay relative ${className}`}
      data-nc-id="SectionClientSay"
    >
      {/* Header with Google Reviews Badge */}
      <div className="text-center mb-12">
        <Heading desc="Real experiences from international students in Lima" isCenter>
          What Our Students Say
        </Heading>
        
        {/* Google Reviews Summary */}
        <div className="mt-8 flex flex-col items-center gap-4">
          <div className="flex items-center gap-3">
            {renderStars(5)}
            <span className="text-2xl font-bold text-neutral-900 dark:text-neutral-100">
              5.0
            </span>
          </div>
          <p className="text-neutral-600 dark:text-neutral-400">
            Based on {GOOGLE_REVIEWS.length}+ verified student reviews
          </p>
        </div>
      </div>

      <div className="relative md:mb-16 max-w-2xl mx-auto">
        {renderBg()}
        
        {/* Main image with enhanced styling */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-[#F56948]/10 to-[#F56948]/5 rounded-full blur-3xl" />
          <img className="mx-auto relative z-10" src={clientSayMain} alt="" />
        </div>

        <div className={`mt-12 lg:mt-16 relative ${UNIQUE_CLASS}`}>
          <img
            className="opacity-50 md:opacity-100 absolute -mr-16 lg:mr-3 right-full top-1"
            src={quotationImg}
            alt=""
          />
          <img
            className="opacity-50 md:opacity-100 absolute -ml-16 lg:ml-3 left-full top-1"
            src={quotationImg2}
            alt=""
          />
          
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              {GOOGLE_REVIEWS.map((item) => (
                <li
                  key={item.id}
                  className="glide__slide flex flex-col items-center text-center px-4"
                >
                  {/* Star Rating */}
                  <div className="mb-6">
                    {renderStars(item.rating)}
                  </div>

                  {/* Review Content */}
                  <span className="block text-xl md:text-2xl text-neutral-700 dark:text-neutral-300 leading-relaxed max-w-xl">
                    "{item.content}"
                  </span>

                  {/* Reviewer Info */}
                  <div className="mt-8">
                    <span className="block text-xl md:text-2xl font-semibold text-neutral-900 dark:text-neutral-100">
                      {item.clientName}
                    </span>
                    <div className="flex items-center justify-center space-x-2 text-base md:text-lg mt-2 text-neutral-400">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={1.5}
                          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                        />
                      </svg>
                      <span>{item.clientAddress}</span>
                    </div>
                  </div>

                  {/* Google Badge */}
                  <div className="mt-6 flex items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                    </svg>
                    <span>Posted on Google</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation Bullets */}
          <div
            className="mt-10 glide__bullets flex items-center justify-center gap-2"
            data-glide-el="controls[nav]"
          >
            {GOOGLE_REVIEWS.map((item, index) => (
              <button
                key={item.id}
                className="glide__bullet w-2.5 h-2.5 rounded-full bg-neutral-300 dark:bg-neutral-600 focus:outline-none transition-all duration-200 hover:bg-[#F56948] data-[active]:bg-[#F56948] data-[active]:w-8"
                data-glide-dir={`=${index}`}
              ></button>
            ))}
          </div>
        </div>

        {/* Read More on Google Button */}
        <div className="mt-12 text-center">
          <a
            href={GOOGLE_BUSINESS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white dark:bg-neutral-800 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 border border-neutral-200 dark:border-neutral-700 hover:scale-105 group"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            <span className="text-base font-semibold text-neutral-900 dark:text-neutral-100 group-hover:text-[#F56948] dark:group-hover:text-[#F56948] transition-colors">
              Read all reviews on Google
            </span>
            <svg
              className="w-5 h-5 text-neutral-400 group-hover:text-[#F56948] dark:group-hover:text-[#F56948] transition-all group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SectionClientSay;